import { render, staticRenderFns } from "./AlzuhudHeader.vue?vue&type=template&id=b70cf7f4&scoped=true"
import script from "./AlzuhudHeader.vue?vue&type=script&lang=ts"
export * from "./AlzuhudHeader.vue?vue&type=script&lang=ts"
import style0 from "./AlzuhudHeader.vue?vue&type=style&index=0&id=b70cf7f4&prod&lang=scss"
import style1 from "./AlzuhudHeader.vue?vue&type=style&index=1&id=b70cf7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70cf7f4",
  null
  
)

export default component.exports